import { makeStyles, Theme } from "@material-ui/core";
import { alpha } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: any) => ({
  view: {
    display: "flex",
    height: "100%"
  },
  content: {
    padding: "1rem"
  },
  contentArea: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    height: "100%",
    background: "rgb(236, 235, 239)",
    maxHeight: "-webkit-fill-available",
    maxWidth: "calc(100% - 240px)",
    overflow: "hidden"
  },
  container: {
    padding: "3rem"
  },
  tableContainer: {
    height: "calc(100% - 53px)",
    padding: "1rem",
    width: "auto",
    overflowY: "auto"
  },
  processingAnimationContainer: {
    display: "flex",
    flexDirection: "column"
  },
  progressContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  progress: {
    height: "calc(100vh - 125px)",
    padding: "1rem",
    width: "100%",
    alignItems: "center",
    display: "flex",
    justifyContent: "center"
  },
  hidden: {
    visibility: "hidden"
  },

  alertInfoContainer: {},
  selected: {
    backgroundColor: "#f4f4f4"
  },
  headContainer: { display: "flex", alignItems: "center" },
  blueFilter: { fill: "#1976d2" },
  filterStyle: { marginLeft: "10px" },
  dateColumn: { minWidth: "135px" },
  tablePaper: {
    background: "#fefefe",
    padding: "20px",
    paddingTop: 0,
    borderRadius: "4px",
    boxShadow: "0 2px 5px -5px rgba(180, 175, 203, 0.63)",
    border: "solid 1px #ebebeb",
    height: "calc(100vh - 125px)"
  },
  tablePagesHeader: { display: "flex", justifyContent: "flex-end" },
  columnsTitles: {
    border: "none",
    padding: "9px 15px",
    fontSize: "13px",
    color: "#79797d",
    fontWeight: "bold",
    lineHeight: "normal",
    letterSpacing: "normal",
    backgroundColor: "#efeff2"
  },
  pagingStyle: { border: "none" },
  wrapper: {
    flex: 1,
    minHeight: 0,
    padding: "1rem 1rem",
    background: "rgb(236, 235, 239)",
    flexFlow: "row nowrap"
  },

  titleContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "20%",
    paddingLeft: "0.5rem",
    color: "#4b1c46"
  },
  buttonContainer: {
    justifyContent: "flex-end",
    paddingRight: "1rem",
    display: "flex",
    alignItems: "center",
    width: "20%",
    color: "#4b1c46"
  },

  filterContainer: {
    height: "100%",
    paddingRight: "1rem",
    minWidth: "300px"
  },
  tableWrapper: {
    height: "100%",
    display: "flex",
    flexFlow: "column nowrap",
    width: "83.333333%",
    maxWidth: "calc(100% - 270px)"
  },
  filterGridItem: {
    height: "39%",
    width: "100%",
    background: theme.palette.background.paper,
    borderRadius: 4,
    display: "flex",
    flexDirection: "column",
    padding: "1rem",
    "&:first-child": {
      borderBottom: "1rem solid #efeff2"
    },
    overflow: "auto",

    marginRight: "1rem"
  },
  filterOutdoorGridItem: {
    height: "30.5%",
    width: "100%",
    background: theme.palette.background.paper,
    borderRadius: 4,
    display: "flex",
    flexDirection: "column",
    padding: "1rem",
    "&:first-child": {
      borderBottom: "1rem solid #efeff2"
    },
    overflow: "auto",
    marginRight: "1rem"
  },
  filterContainerBs: {
    height: "35%"
  },
  filterBsGridItem: {
    height: "28%",
    width: "100%",
    background: theme.palette.background.paper,
    borderRadius: 4,
    display: "flex",
    flexDirection: "column",
    padding: "1rem",
    "&:first-child": {
      borderBottom: "1rem solid #efeff2"
    },
    overflow: "auto",
    marginRight: "1rem",
    marginBottom: "1rem"
  },

  filter: {
    height: "100%",
    overflow: "auto",
    marginBottom: "1rem",
    display: "flex",
    flexDirection: "column"
  },

  // ---- Audits table
  tablesContainer: {
    height: "100%",
    // width: "20rem",
    display: "flex",
    flexDirection: "column",
    flexWrap: "nowrap"
  },
  tableGridItem: {
    height: "39%",
    display: "flex",
    padding: "1rem",
    // overflow: "auto",
    background: "#fff",
    borderRadius: "4px",
    flexDirection: "column"
  },
  tableBsGridItem: {
    height: "28%",
    display: "flex",
    padding: "1rem",
    overflow: "auto",
    background: "#fff",
    borderRadius: "4px",
    flexDirection: "column",
    marginBottom: "1rem"
  },
  tableOutdoorGridItem: {
    height: "35%",
    display: "flex",
    padding: "1rem",
    overflow: "auto",
    background: "#fff",
    borderRadius: "4px",
    flexDirection: "column",
    borderBottom: "1rem solid #efeff2"
  },
  tableOutdoorGridItemBs: {
    height: "30.5%"
  },
  filterGridItemBs: {
    height: "65%"
  },
  table: {
    background: theme.palette.background.paper
  },
  tableHeadRow: {
    height: "3rem"
  },
  overWritePadding: {},
  tableCell__icon: {
    width: 30
  },
  tableCell__date: {
    width: "24ch",
    paddingLeft: 0
  },
  tableCell__actor: {
    width: "20ch"
  },
  tableCell__unit: {
    width: "15ch"
  },
  tableCell__actionOnSubject: {
    width: "25ch"
  },
  tableCell__subject: {
    width: "15ch"
  },
  tableCell__data: {
    width: "auto"
  },
  slider: {
    width: "50%",
    margin: "1rem",
    color: "grey"
    // backgroundColor: "grey",
  },
  sliderContainer: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    flex: 1,
    minHeight: "70px"
    // paddingLeft: "1rem",
  },
  headerContainer: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    width: "100%",
    justifyContent: "space-between",
    padding: "0 16px",
    flexFlow: "row nowrap",
    minHeight: "min-content"
  },
  valueLabel: {
    // span: {
    "&:.PrivateValueLabel-circle": {
      borderRadius: "50% 0 50% 50% !important",
      color: "red"
      //   },
    },
    top: "30px"
  },
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: "0 4px 12px 0 rgba(180, 175, 203, 0.63)",
    fontSize: 12,
    paddingLeft: 12,
    paddingRight: 12,
    fontWeight: 600
  },
  tooltipArrow: {
    color: theme.palette.common.white,
    filter: "drop-shadow(0 4px 6px rgba(180, 175, 203, 0.63))"
  },
  tooltipPopper: {
    zIndex: 1
  },
  headerButton: {
    minHeight: "40px",
    maxHeight: "40px",
    minWidth: "169px",
    fontSize: "16px",
    fontWeight: "normal",
    lineHeight: "normal",
    color: "#fff",
    textTransform: "capitalize"
  },
  noSysText: {
    display: "flex",
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    fontSize: "24px"
  },
  contentContainer: {
    width: "100%",
    height: "100%",
    padding: "0.5rem",
    boxSizing: "border-box",
    overflowX: "hidden"
  },
  noContentContainer: {
    boxShadow: "0 2px 5px -5px rgba(180, 175, 203, 0.63)",
    backgroundColor: "#fefefe",
    justifyContent: "center",
    alignItems: "center",
    padding: 0,
    width: "calc(100% - 60px)",
    height: "calc(100% - 130px)",
    alignSelf: "center",
    marginTop: "30px"
  },
  grayOval: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "136px",
    height: "136px",
    backgroundColor: "rgba(170, 162, 170, 0.1)",
    borderRadius: "50%"
  },
  arrowIcon: { fontSize: "91px", transform: "rotate(90deg)" },
  noUnitText: {
    fontSize: "26px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    textAlign: "center",
    color: "#545964",
    marginTop: "43px"
  },
  iconBtnStyle: {
    width: 30,
    height: 30,
    borderRadius: 6,
    padding: 0
  },
  inputRoot: {
    color: theme.palette.colors.menuFont,
    fontFamily: "Roboto",
    fontSize: "13px",
    width: "300px",
    display: "flex",
    flexDirection: "row",
    height: "36px",
    borderRadius: "4px",
    padding: "0 15px",
    backgroundColor: theme.palette.colors.mainSearchBackground,
    maxWidth: "70%",
    marginRight: "40px"
  },
  searchIcon: {
      color: "#fff"
  },
  autoCompletePoper: {
      backgroundColor: theme.palette.primary.dark
  },
  autoCompleteItem: {
      backgroundColor: "rgba(0,0,0,0)",
      color: "#fff",
      "& li": {
          margin: "5px 10px"
      }
  },
  autoCompletePaper: {
      backgroundColor: "rgba(0,0,0,0)"
  },
  autoCompleteGroup: {
      backgroundColor: theme.palette.primary.dark, //"rgba(0,0,0,0)",
      color: "#fff",
      fontWeight: "bold",
      fontSize: "17px"
  },
  autoCompleteGroupUl: {
    backgroundColor: theme.palette.background.searchList
  },
  autoLabel: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '9px',
    color: '#4B1C46',
    fontSize: '16px',
    fontWeight: 500,
    letterSpacing: 'normal',
    lineHeight: '21px',
  },
  switchIcon: {
    height: "24px", width: "45px"
  },
  switchIconBtn: {
    backgroundColor: 'transparent !important'
  },
  timelineCard: {
    backgroundColor: '#fff',
    padding: '11px 30px',
    boxShadow: '0px 2px 1.5px rgba(84,89,100,0.07)',
    transition: 'opacity 0.2s ease',
  },
  timelineRow: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    flexWrap: 'nowrap',
    gap: '24px',
  },
  leftGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: '40px',
    flex: 1,
    minWidth: 0,
    '@media (max-width: 1173px)': {
      flexDirection: 'column',
      alignItems: 'stretch',
    },
  },
  timePill: {
    display: 'flex',
    alignItems: 'center',
    gap: '24px',
    flex: 1,
    padding: '15px 14px',
    borderRadius: '200px',
  },
  tdate: {
    fontSize: '16px',
    color: '#545964',
    whiteSpace: 'nowrap',
    fontWeight: 600,
    flexShrink: 0,
  },
  sliderWrap: {
    flex: 1,
    minWidth: '100px',
    display: 'flex',
    alignItems: 'center',
  },
  customSlider: {
    height: 4,
    padding: '13px 0',
    '& .MuiSlider-track': {
      height: 4,
      borderRadius: 200,
    },
    '& .MuiSlider-rail': {
      height: 4,
      borderRadius: 200,
      backgroundColor: '#E0E0E0',
      opacity: 1,
    },
    '& .MuiSlider-thumb': {
      height: 14,
      width: 14,
      backgroundColor: theme.palette.primary.main,
      border: 'none',
      boxShadow: `0 0 0 1px #fff, 0 0 0 3px ${alpha(theme.palette.primary.main, 0.25)}`,
      marginTop: -5,
      marginLeft: -7,
    },
  },
  playerControls: {
    display: 'flex',
    alignItems: 'center',
    gap: '20px',
    flexShrink: 0,
    height: 56,
    padding: '10px 24px',
    borderRadius: '200px',
  },
  playerBtn: {
    border: 'none',
    outline: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
    transition: 'all 0.15s ease',
    userSelect: 'none',
  },
  jumpBtn: {
    width: 20,
    height: 20,
    borderRadius: '50%',
    backgroundColor: 'transparent',
    color: '#7F7182',
    '& svg': {
      width: 14,
      height: 14,
    },
  },
  playBtn: {
    width: 40,
    height: 40,
    borderRadius: '50%',
    backgroundColor: 'transparent',
    color: '#4B1C46',
    '& circle': {
      transition: 'fill 0.15s ease',
    },
    '&:hover circle': {
      fill: '#F1ECF2',
    },
  },
  seekBtn: {
    width: 34,
    height: 34,
    borderRadius: '50%',
    backgroundColor: 'transparent',
    position: 'relative',
    '& svg': {
      flexShrink: 0,
      overflow: 'visible',
    },
  },
  seekBadge: {
    position: 'absolute',
    top: -5,
    right: -7,
    backgroundColor: '#D8CEDA',
    color: '#3a2f3d',
    fontSize: '9.5px',
    fontWeight: 700,
    padding: '1px 4px',
    borderRadius: '60px',
    border: '1px solid #FFF',
    lineHeight: '1.2',
    pointerEvents: 'none',
  },
  divider: {
    width: 1,
    height: 44,
    backgroundColor: '#D5D2D5',
    flexShrink: 0,
  }
}));

export default useStyles;
